// Third party
import { createSlice } from '@reduxjs/toolkit';
import storage from 'redux-persist/lib/storage';
import { persistReducer } from 'redux-persist';

import { reducers } from './reducers';

// Data
import { PERSIST_KEYS, STORE_SLICES } from '../../utils/enums';
import { IRootState } from './type';

// Types

const initialState: IRootState = {
  dashboardData: {
    latestOrders: [],
    mainChart: {
      data: [],
      labels: [],
    },
    orders: {},
    sheets: {},
    transactions: {},
  } as unknown as IRootState['dashboardData'],
  yearlyData: {} as IRootState['dashboardData'],
  monthlyData: {} as IRootState['dashboardData'],
  preset: 'today',
};
export const slice = createSlice({
  name: STORE_SLICES.DASHBOARD,
  initialState,
  reducers,
});
const dashboardActions = slice.actions;

const dashboardPersistConfig = {
  key: PERSIST_KEYS.DASHBOARD,
  storage,
  whitelist: ['dashboardData', 'yearlyData', 'monthlyData', 'preset'],
};

export {
  dashboardActions,
};

export default persistReducer(dashboardPersistConfig, slice.reducer);
